import React from "react";
import { ScrollView, Text, View, Linking, TouchableOpacity, Image } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";

const parseDescription = (description) => {
  return description.map((desc, index) => {
    if (desc.includes("<a")) {
      const href = desc.match(/href='(.*?)'/)[1];
      const label = desc.match(/>(.*?)<\/a>/)[1];
      const textBeforeLink = desc.split("<a")[0];
      const textAfterLink = desc.split("</a>")[1];

      return (
        <Text
          key={index}
          style={[
            AppFontStyle.REGULAR_ANYBODY_12,
            { color: AppColors.white, lineHeight: 15, marginBottom: 3 },
          ]}
        >
          {`${index + 1}. `}
          {textBeforeLink}
          <Text
            style={{ textDecorationLine: "underline", color: AppColors.white }}
            onPress={() => Linking.openURL(href)}
          >
            {label}
          </Text>
          {textAfterLink}
        </Text>
      );
    }

    return (
      <Text
        key={index}
        style={[
          AppFontStyle.REGULAR_ANYBODY_12,
          { color: AppColors.white, lineHeight: 15, marginBottom: 3 },
        ]}
      >
        {`${index + 1}. `}
        {desc}
      </Text>
    );
  });
};

const HelpCenterAccordionComponent = ({ steps, expandedStep, setExpandedStep, isDescriptionEmpty = false }) => {
  const deviceSize = useDeviceSize();

  const toggleStep = (stepId) => {
    setExpandedStep((prevStep) => (prevStep === stepId ? null : stepId));
  };

  return steps.map((step, index) => (
    <React.Fragment key={index}>
      <View
        style={{
          borderBottomWidth: index !== steps.length - 1 ? 1 : 0,
          borderBottomColor: AppColors.white,
        }}
      >
        <TouchableOpacity
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            paddingVertical:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? 10 : 20,
            paddingHorizontal:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM ? 15 : 50,
            borderRadius: 5,
            zIndex: 1,
          }}
          onPress={() => toggleStep(index)}
        >
          <Text style={AppFontStyle.REGULAR_ANYBODY_12}>{step.StepTitle}</Text>
          <Image
            source={
              expandedStep === index
                ? AppImages.icDownLineArrow
                : AppImages.icRightLineArrow
            }
            style={{ width: expandedStep === index ? 10 : 5, height: 10 }}
          />
        </TouchableOpacity>
      </View>

      {expandedStep === index && (
        <ScrollView
          style={{
            maxHeight: 220,
            backgroundColor: AppColors.appGreenColor_51AF07,
            paddingTop: 20,
            paddingRight: 30,
            paddingLeft: 30,
            paddingBottom: 15,
            borderRadius: 5,
            zIndex: 999,
            elevation: 5,
          }}
        >
          {parseDescription(step.Description)}
        </ScrollView>
      )}
    </React.Fragment>
  ));
};

export default HelpCenterAccordionComponent;
